import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type GoBackToPcfListButtonProps = {
  url: string;
};

const GoBackToPcfListButton = ({ url }: GoBackToPcfListButtonProps) => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <Button
      className='justify-content-center text-sm p-0 mt-2 max-w-fit'
      text
      icon='pi pi-arrow-circle-left'
      onClick={() => {
        return navigate(url);
      }}
      label={t('productDetailsPage.tabs.pcfTab.buttons.goBackButton')}
    />
  );
};

export default GoBackToPcfListButton;
